// Helper: Layout > Get fixed vertical layout height
function getFixedVerticalLayoutHeight () {
	let height = 0
	// const navigationHeight = Number(window.getComputedStyle(document.getElementById('navigation')).getPropertyValue('height').match(/\d+/)[0])
	// height += navigationHeight
	const fixedHeader = document.querySelector('[data-header].aix-sticky')
	if (!!fixedHeader) {
		const fixedHeaderHeight = Number(window.getComputedStyle(fixedHeader).getPropertyValue('height').match(/\d+/)[0])
		height += fixedHeaderHeight
	}
	const fixedTabbing = document.querySelector('[data-section="tabbing"].aix-sticky')
	if (!!fixedTabbing) {
		const fixedTabbingHeight = Number(window.getComputedStyle(fixedTabbing).getPropertyValue('height').match(/\d+/)[0])
		const fixedTabbingMargin = Number(window.getComputedStyle(fixedTabbing).getPropertyValue('margin-bottom').match(/\d+/)[0])
		height += fixedTabbingHeight + fixedTabbingMargin
	}
	return height
}

// Helper: Layout > Scroll to section
function scrollToSection (name, willRecheck = false) {
	const section = document.querySelector(`[data-section="${name}"]`)
	if (section?.querySelector('.aix-section-content:not(:empty)')) {
		let { top } = section.getBoundingClientRect()
		top += window.scrollY
		top -= getFixedVerticalLayoutHeight()
		window.scrollTo({ behavior: 'smooth', top })
	} else if (willRecheck) setTimeout(() => scrollToSection(name, false), 1000)
}

// Export
export {
	getFixedVerticalLayoutHeight,
	scrollToSection
}
